export type Stage = {
  number: number;
  title: string;
  minutes: number;
  intro: string;
  items: string[];
  objective: string;
};

export const stages: Stage[] = [
  {
    number: 1,
    title: "Patient History Review",
    minutes: 3,
    intro: "Organize the available information about:",
    items: [
      "Hair loss onset and progression.",
      "Shedding versus thinning.",
      "Relevant medical history.",
      "Family history.",
      "Potential contributing factors.",
      "Previous assessments and treatments.",
    ],
    objective: "Complete a structured initial review of the available patient history.",
  },
  {
    number: 2,
    title: "Hair Loss Pattern Assessment",
    minutes: 3,
    intro: "Review the documented presentation:",
    items: [
      "Diffuse hair loss.",
      "Localized or patchy hair loss.",
      "Patterned thinning.",
      "Scalp inflammation.",
      "Visible follicular changes.",
      "Possible scarring features.",
    ],
    objective: "Organize the observed hair loss pattern into a clear assessment record.",
  },
  {
    number: 3,
    title: "Trichoscopy Findings Review",
    minutes: 3,
    intro: "Use the visual references to organize observations such as:",
    items: [
      "Hair shaft diameter variation.",
      "Yellow dots and black dots.",
      "Broken hairs.",
      "Follicular opening characteristics.",
      "Perifollicular changes.",
      "Other relevant trichoscopic features.",
    ],
    objective: "Record relevant findings for further clinical interpretation.",
  },
  {
    number: 4,
    title: "Differential Diagnosis Review",
    minutes: 4,
    intro:
      "Compare available findings against structured educational references covering 12 alopecia conditions. Review:",
    items: [
      "Relevant clinical patterns.",
      "Associated trichoscopic findings.",
      "Potentially overlapping presentations.",
      "Features requiring additional evaluation.",
      "Diagnostic uncertainty.",
    ],
    objective:
      "Organize possible diagnostic considerations without prematurely concluding a diagnosis.",
  },
  {
    number: 5,
    title: "Documentation & Next Steps",
    minutes: 2,
    intro: "Bring the information together.",
    items: [
      "Record the initial findings.",
      "Identify missing information.",
      "Document relevant concerns.",
      "Note questions requiring further assessment.",
      "Organize appropriate follow-up considerations.",
    ],
    objective: "Complete a structured initial assessment worksheet.",
  },
];

export const imagineSteps = [
  "You open your assessment framework.",
  "You organize the patient’s available history.",
  "You document the observed hair loss pattern.",
  "You review relevant scalp and trichoscopic findings.",
  "You identify possible differential diagnosis considerations.",
  "And you record the information that may require additional professional evaluation.",
];

export const searchLoop = [
  "You opened one reference.",
  "Then another.",
  "Then searched for an image.",
  "Then returned to your clinical notes.",
];
